/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.InstitutionType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.InstitutionType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum InstitutionType_ {
   /// <summary>
   ///   Unknown (Unknown)
   /// </summary>
   Unknown = 0,
   /// <summary>
   ///   Public (Public)
   /// </summary>
   Public = 1,
   /// <summary>
   ///   Private (Private)
   /// </summary>
   Private = 2,
   /// <summary>
   ///   Homeschool (Home)
   /// </summary>
   Homeschool = 3
}

export const InstitutionTypes: InstitutionType[] = [
   {
      code: InstitutionType_.Unknown,
      literal: 'Unknown',
      description: 'Unknown',
      shortDescription: 'Unknown',
      listPriority: 3,

      typeName: "InstitutionType"
   },
   {
      code: InstitutionType_.Public,
      literal: 'Public',
      description: 'Public',
      shortDescription: 'Public',
      listPriority: 0,

      typeName: "InstitutionType"
   },
   {
      code: InstitutionType_.Private,
      literal: 'Private',
      description: 'Private',
      shortDescription: 'Private',
      listPriority: 1,

      typeName: "InstitutionType"
   },
   {
      code: InstitutionType_.Homeschool,
      literal: 'Homeschool',
      description: 'Homeschool',
      shortDescription: 'Home',
      listPriority: 2,

      typeName: "InstitutionType"
   }
]

export class InstitutionType implements IDomainModel {
   code: InstitutionType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: InstitutionType_): InstitutionType {
      return InstitutionTypes.find(d => d.code === code)
   }
}
